export const get_user_details = "https://aloxa.ai/flaskservice/get_user_details"
export const doctor_login = "https://aloxa.ai/flaskservice/doctor_login"
export const getPrescriptionID = "https://aloxa.ai/flaskservice/get_prescription_id"
export const getReviewPrescriptionForAdmin = "https://aloxa.ai/flaskservice/get_review_prescription"
export const addPrescriptionDetails = "https://aloxa.ai/flaskservice/add-prescription"
export const getUserPrescriptionCount = " https://aloxa.ai/flaskservice/get_user_prescription_count"

export const getOtp = "https://aloxa.ai/flaskservice/getotp"
export const verifyOtp = "https://aloxa.ai/flaskservice/verifyotp"

export const getDoctorsPrescriptionlist = "https://aloxa.ai/flaskservice/get_doctors_prescriptionlist"
export const getAdminPrescriptionlist = "https://aloxa.ai/flaskservice/get_admin_prescriptionlist"

//Compounders API
export const getCompounderByPhone = "https://aloxa.ai/flaskservice/get_compounder_by_phone"
export const getCompounderOrderList = "https://aloxa.ai/flaskservice/get_orders_details"
export const postFulfillOrder = "https://aloxa.ai/flaskservice/fulfill_order"

// `https://aloxa.ai/flaskservice/api/hair-analysis/${
//           currentId != "" ? currentId : mainAnalysisId
//         }/validation-review`,